import { inject, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AddItemWishListRequest } from '../interfaces/add-item-wish-list-request.interface';
import { catchError, map, Observable, of } from 'rxjs';
import { ModalService } from './modal.service';
import { CreateWishListRequest } from '../interfaces/create-wish-list-request.interface';
import { CatalogOptionResponse } from '../interfaces/catalog-option-response.interface';
import { GetWishListDetailResponse } from '../interfaces/get-wish-list-detail-response.interface';
import { MoveItemWishListRequest } from '../interfaces/move-item-wish-list-request.interface';

const API_URL = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class WishListService {
  private http = inject(HttpClient);
  private modalService = inject(ModalService);

  #originTypeId = 'a80c8eb3-d79a-48c8-957d-182f0af90254';
  #wishListUrl = `${API_URL}/wishList`;

  addItemWishList(
    detailCatalogId: string,
    wishListId: string,
  ): Observable<boolean> {
    const request: AddItemWishListRequest = {
      detailCatalogId,
      wishListId,
      originTypeId: this.#originTypeId,
    };
    return this.http.post(`${this.#wishListUrl}/addItem`, request).pipe(
      map(() => true),
      catchError((err: HttpErrorResponse) => {
        this.modalService.showErrorModal(err);
        return of(false);
      }),
    );
  }

  createWishList(detailCatalogId: string, name: string): Observable<boolean> {
    const request: CreateWishListRequest = {
      detailCatalogId,
      name,
      originTypeId: this.#originTypeId,
    };
    return this.http.post(`${this.#wishListUrl}/create`, request).pipe(
      map(() => true),
      catchError((err: HttpErrorResponse) => {
        this.modalService.showErrorModal(err);
        return of(false);
      }),
    );
  }

  getWishList(): Observable<CatalogOptionResponse[]> {
    return this.http.get<CatalogOptionResponse[]>(`${this.#wishListUrl}/get`);
  }

  getWishListDetail(
    wishListId: string,
  ): Observable<GetWishListDetailResponse[]> {
    const params = new HttpParams().set('wishListId', wishListId);

    return this.http.get<GetWishListDetailResponse[]>(
      `${this.#wishListUrl}/getDetail`,
      { params },
    );
  }

  removeItem(detailWishListId: string): Observable<boolean> {
    const params = new HttpParams().set('detailWishListId', detailWishListId);

    return this.http
      .post(`${this.#wishListUrl}/removeItem`, null, { params })
      .pipe(
        map(() => true),
        catchError((err: HttpErrorResponse) => {
          this.modalService.showErrorModal(err);
          return of(false);
        }),
      );
  }

  removeWishList(wishListId: string): Observable<boolean> {
    const params = new HttpParams().set('wishListId', wishListId);

    return this.http.post(`${this.#wishListUrl}/remove`, null, { params }).pipe(
      map(() => true),
      catchError((err: HttpErrorResponse) => {
        this.modalService.showErrorModal(err);
        return of(false);
      }),
    );
  }

  moveItemWishList(request: MoveItemWishListRequest): Observable<boolean> {
    return this.http.post(`${this.#wishListUrl}/moveItem`, request).pipe(
      map(() => true),
      catchError((err: HttpErrorResponse) => {
        this.modalService.showErrorModal(err);
        return of(false);
      }),
    );
  }
}
